import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NoItemsProps {
    message?: string;
}

const NoItems = ({ message }: NoItemsProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col justify-center items-center h-[100px] 0">
            <p className="text-xl text-gray-500">
                {message || t('actions.noResults')}
            </p>
        </div>
    );
};

export default NoItems;
